<template>
  <div class="join-box">
    <img class="join_top" :src="IMG+'/img_page.png'">
    <img class="join_bt" :src="IMG+'/hezuo_bt.png'">
  </div>
</template>
<script>
export default {
  data() {
    return {
      IMG: this.img_host,
    }
  },
  // 页面创建前
  beforeCreate() {
    // document.querySelector('body').setAttribute('style', 'background:#f7f7f7');
  },
  methods: {}
}

</script>
<style scoped>
.join-box {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;

}
.join-box img {
  vertical-align: top;
}
.join_top {
  width: 1200px;
  height: 690px;
}
.join_bt {
  width: 1200px;
  height: 844px
}

</style>



// WEBPACK FOOTER //
// src/components/joinUs.vue